
import React from 'react';
import { connect } from 'react-redux';
import {updateAccessorial, getAccessorials, getAccessorialsTXT, importJSON} from './AccessorialsAndFeesActions';
import AccessorialRateManagementWidget from '../../components/AccessorialsAndFees/AccessorialRateManagementWidget';
import { setAccessorialRateUi } from './AccessorialsAndFeesUiActions';

class AccessorialsAndFeesManageContainer extends React.Component {

  render() {

    const { importAccessorials, rateSheet, terminals, dispatchGetAccessorialsTXT,dispatchImportJSON, uiState, dispatchUpdateAccessorial, dispatchGetAccessorials, setUiState } = this.props;
    return (
      <AccessorialRateManagementWidget
        rateSheet={rateSheet}
        terminals={terminals}
        importAccessorials={importAccessorials}
        uiState={uiState}
        dispatchGetAccessorialsTXT={dispatchGetAccessorialsTXT}
        dispatchImportJSON={dispatchImportJSON}
        dispatchUpdateAccessorial={dispatchUpdateAccessorial}
        dispatchGetAccessorials={dispatchGetAccessorials}
        setUiState={setUiState}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  rateSheet: state.business.rateSheet,
  terminals: state.business.terminals,
  importAccessorials: state.importAccessorials,
  uiState: state.accessorialRateUi.accessorialRateUi.toObject(),
});


const mapDisptatchToProps = (dispatch) => ({
  dispatchImportJSON: (parameters, callback) => dispatch(importJSON(parameters, callback)),
  dispatchUpdateAccessorial: (parameters, callback) => dispatch(updateAccessorial(parameters, callback)),
  dispatchGetAccessorialsTXT: (parameters, cb) => dispatch(getAccessorialsTXT(parameters, cb)),
  dispatchGetAccessorials: (parameters, cb) => dispatch(getAccessorials(parameters, cb)),
  setUiState: state => dispatch(setAccessorialRateUi(state))
});



export default connect(mapStateToProps, mapDisptatchToProps)(AccessorialsAndFeesManageContainer);


// WEBPACK FOOTER //
// ./src/containers/AccessorialsAndFees/AccessorialsAndFeesManageContainer.js